<div [ngClass]="overlay ? 'loading-overlay-container' : 'loading-container'" id="loading-container">
    <img *ngIf="globalLoader" [src]="'assets/images/app-loader.gif'" alt="mouse-loader" id="app-loader-image" />
    <div class="dot-flashing" *ngIf="!globalLoader"></div>
    <p id="app-loader-text" *ngIf="globalLoader">{{ 'loaderText' | translate }}</p>
</div>
